import script from "./input-multi-select.vue?vue&type=script&setup=true&lang=js"
export * from "./input-multi-select.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__